// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2564":"2f2218fc260c384a","4879":"03566e000f2e47e5"}[chunkId] + ".css";
};